/**
 * Per-tab persistence of whether the full-screen FileEmptyState has already
 * been shown for a given file.
 *
 * Stored in sessionStorage (not localStorage) so it survives a page refresh in
 * the same tab but does not leak to other tabs: opening the file in a new tab
 * gets a fresh session and shows the empty state again. A different file simply
 * won't match the stored fileUuid, so it shows the empty state as expected.
 */

const SESSION_KEY = 'fileEmptyStateShown';

type FileEmptyStateShown = {
  fileUuid: string;
};

export const readFileEmptyStateShown = (): FileEmptyStateShown | undefined => {
  try {
    if (typeof window === 'undefined') return undefined;
    const saved = window.sessionStorage.getItem(SESSION_KEY);
    if (!saved) return undefined;
    const parsed = JSON.parse(saved);
    if (parsed && typeof parsed.fileUuid === 'string') {
      return parsed;
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const writeFileEmptyStateShown = (fileUuid: string): void => {
  try {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify({ fileUuid }));
  } catch {
    // Ignore write failures (e.g. storage disabled or quota exceeded).
  }
};
